import React from 'react';
import { Link } from 'react-router-dom';
import './footer.css';

const Footer = () => {
    return (
        <footer className="footer-container">
            <div className="container">
                <div className="row justify-content-center">
                    {/* Columna de Contacto */}
                    <div className="col-md-4 mb-4 mb-md-0">
                        <h5 className="text-glow mb-4">Contacto</h5>
                        <ul className="contact-list">
                            <li className="contact-item">
                                <i className="bi bi-telephone-fill"></i>
                                <span>+569 4354 6573</span>
                            </li>
                            <li className="contact-item">
                                <i className="bi bi-telephone-fill"></i>
                                <span>+569 9953 2412</span>
                            </li>
                            <li className="contact-item">
                                <i className="bi bi-envelope-fill"></i>
                                <span>contacto@angularstone.cl</span>
                            </li>
                            <li className="contact-item">
                                <i className="bi bi-globe"></i>
                                <span>https://angularstone.cl</span>
                            </li>
                        </ul>
                    </div>

                    {/* Enlaces Rápidos */}
                    <div className="col-md-4 mb-4 mb-md-0">
                        <h5 className="text-glow mb-4">Enlaces Rápidos</h5>
                        <ul className="quick-links">
                            <li>
                                <Link to="/">
                                    <i className="bi bi-chevron-right"></i>
                                    <span>Inicio</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/servicios">
                                    <i className="bi bi-chevron-right"></i>
                                    <span>Servicios</span>
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Servicios */}
                    <div className="col-md-4 mb-4 mb-md-0">
                        <h5 className="text-glow mb-4">Servicios</h5>
                        <ul className="services-list">
                            <li>
                                <i className="bi bi-diagram-3-fill"></i>
                                <span>GAP Análisis Framework</span>
                            </li>
                            <li>
                                <i className="bi bi-display"></i>
                                <span>Servicios de Monitoreo</span>
                            </li>
                            <li>
                                <i className="bi bi-bug"></i>
                                <span>Ethical Hacking</span>
                            </li>
                            <li>
                                <i className="bi bi-shield-lock"></i>
                                <span>Ciberseguridad NIST</span>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Copyright */}
                <div className="footer-bottom">
                    <hr className="footer-divider" />
                    <p className="copyright-text">
                        © 2024 Angular Stone. Todos los derechos reservados.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;